module.exports = __webpack_public_path__ + "static/img/LT@3x.47d4803b.jpg";